import { GzDonutChartWidgetWebComponent } from './component/GzDonutChartWidgetWebComponent';

export { GzDonutChartWidgetWebComponent };
